import ToolsManagerPage from "pages/tools/ToolsManager";
import { Route } from "react-router-dom";
import { MANAGER_TOOLS_PATH } from "constants/constants";

// The tab is optional so the menu and post-login entries (tab-less URL) match
// the same route as a tab URL: the page stays mounted and fills the tab in.
const routes = {
  key: "TOOLS",
  routes: ({ userScope }) => [
    <Route
      path={`${userScope}/${MANAGER_TOOLS_PATH}/:tab?`}
      key={"manager-tool"}
      element={<ToolsManagerPage />}
    />,
  ],
};

export default routes;
